import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo } from 'react';
import { animated, useSpring } from 'react-spring';
import { styled } from 'styled-components';
import { layout, space } from 'styled-system';
import { onEnterPress } from '@hivebrite/utils';
import { Box } from "../../box/src";
import { LinkSimple } from "../../link/src";
import { focusOutline, FONT_BRIGHTNESS_MAPPING, useTheme, } from "../../theme/src";
import { PillIcon } from './components/PillIcon';
const AnimatedBox = animated(Box);
const getBorder = (theme) => `1px solid ${theme.colors.horizon}`;
const PillWrapper = styled(AnimatedBox).attrs(() => ({
    font: 'footnote-asphalt',
    fontWeight: 0,
    minHeight: '24px',
    px: 2,
})) `
  ${focusOutline}
  ${space}
  ${layout}
  align-items: center;
  border-radius: 5px;
  border: ${({ theme }) => getBorder(theme)};
  display: flex;
  justify-content: center;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: break-spaces;
  word-break: break-word;
  width: fit-content;
  cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'auto')};
  pointer-events: ${({ $isClickable }) => ($isClickable ? 'all' : 'none')};
`;
const LinkWrapper = styled(LinkSimple) `
  display: flex;
  overflow: hidden;
`;
export const Pill = (_a) => {
    var { children, href, iconName, iconType, onClick } = _a, otherProps = __rest(_a, ["children", "href", "iconName", "iconType", "onClick"]);
    const theme = useTheme();
    const { frameBackgroundColor, frameFontBrightness } = theme.themeVariables;
    const isClickable = Boolean(href || onClick);
    const initialStyle = useMemo(() => ({
        backgroundColor: frameBackgroundColor,
        borderColor: theme.colors.horizon,
        color: theme.colors[FONT_BRIGHTNESS_MAPPING.asphalt[frameFontBrightness]],
    }), [frameBackgroundColor, frameFontBrightness, theme]);
    const hoverStyle = useMemo(() => ({
        backgroundColor: theme.colors.primaryDark,
        borderColor: theme.colors.primaryDark,
        color: theme.colors.white,
    }), [theme]);
    const [spring, springApi] = useSpring(() => initialStyle);
    const onMouseLeave = useCallback(() => springApi.start(initialStyle), [initialStyle, springApi]);
    const onMouseEnter = useCallback(() => springApi.start(hoverStyle), [hoverStyle, springApi]);
    const handleOnClick = (handler) => handler ? onEnterPress(handler) : undefined;
    const getTabIndex = (func) => (func ? 0 : -1);
    useEffect(() => {
        springApi.start(initialStyle);
    }, [initialStyle, springApi]);
    return href ? (_jsx(LinkWrapper, { to: href, children: _jsxs(PillWrapper, Object.assign({ "$isClickable": isClickable, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, style: spring }, otherProps, { children: [iconName ? _jsx(PillIcon, { iconName: iconName, iconType: iconType }) : null, children] })) })) : (_jsxs(PillWrapper, Object.assign({ "$isClickable": isClickable, onClick: onClick, onKeyPress: handleOnClick(onClick), onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, style: spring, tabIndex: getTabIndex(onClick) }, otherProps, { children: [iconName ? _jsx(PillIcon, { iconName: iconName, iconType: iconType }) : null, children] })));
};
//# sourceMappingURL=Pill.js.map